// extracted by mini-css-extract-plugin
module.exports = {"imagesContainer":"_8jeFo","imageWrapper":"V8x5x","doubleImage":"IcapL","text":"BdlVn"};